"use strict";

import Backbone from 'backbone';
import router from 'Router';
export var Collection = Backbone.Collection.extend({
  fetchParams: {},

  /**
   * Receive data from server and parse it (native backbone function, see documentation)
   * @param data - data from server
   * @return {*} - return parsed data
   */
  parse: function parse(data) {
    var object = this.object;

    if (data.Response && data.Response[object]) {
      this.response = data.Response;
      this.Object = object;
      this.Page = data.Page;
      this.PagesPredict = data.PagesPredict;
      return _(data.Response[object]).map(function (item) {
        return {
          Response: [item]
        };
      });
    } else {
      return false;
    }
  },

  /**
   * Extending native backbone fetch function (see documentation)
   * @param options - extended data for fetch
   * @return {*} - return and call native backbone fetch function
   */
  fetch: function fetch(options) {
    options.data = JSON.stringify(options.data);
    return Backbone.Collection.prototype.fetch.call(this, options);
  },

  /**
   * Native backbone sync function (see documentation)
   */
  sync: function sync(method, model, options) {
    switch (method) {
      case "read":
        options.url = router.createUrl(method, model.object);
        method = 'create';
        break;

      case "create":
        options.url = router.createUrl(method, model.object);
        model = this.prepareCollectionToChange(model);
        break;

      case "update":
        options.url = router.createUrl(method, model.object);
        method = 'create';
        model = this.prepareCollectionToChange(model);
        break;

      case "delete":
        options.url = router.createUrl(method, model.object);
        method = 'create';
        model = this.prepareCollectionToChange(model);
        break;
    }

    if (!options.headers) options.headers = {};
    options.headers['Accept'] = 'application/DirectorWebApi.1.1+json';
    return Backbone.sync.call(this, method, model, options);
  },

  /**
   * Delete/Update/create all models prepared for deleting/updating/creating
   * @param model - model or models for deleting/updating/creating
   * @return {Backbone.Model} - returned model which contains models for deleting/updating/creating (returned model used in sync func (delete/modify/insert method))
   */
  prepareCollectionToChange: function prepareCollectionToChange(model) {
    var singleModel = new Backbone.Model();
    var object = this.models[0].collection.Object || this.object;
    var valuesForServer = {};
    valuesForServer[object] = [];

    _.each(model.models, function (value) {
      valuesForServer[object].push(value.attributes);
    });

    singleModel.set('Request', valuesForServer);
    return singleModel;
  }
});